import { useMutation } from "@tanstack/react-query";

import { checkoutGinoAddon } from "../services/ginoCheckout";

export const useCheckoutGinoAddon = ({ onSuccess }: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: checkoutGinoAddon,
    onSuccess: () => {
      onSuccess?.();
    },
  });
};
